import { useTestProductModalContext } from "@/contexts/TestProductModalContext";

import BaseTestProductModal from "./BaseTestProductModal";
import Full from "./testProductDetail/modal/Full";
import Truncated from "./testProductDetail/modal/Truncated";
import showFullDetails from "./testProductDetail/utils/showFullDetails";

function ProductDetailView() {
  const { testProduct } = useTestProductModalContext();

  if (!testProduct) return null;

  const fullView = showFullDetails(testProduct);

  if (fullView) {
    return <Full />;
  } else {
    return <Truncated />;
  }
}

export default function TestProductModal({ bg }) {
  return (
    <BaseTestProductModal
      bg={bg}
      productDetailView={<ProductDetailView />}
    />
  );
}
